import { pr } from '@/utils/pxToRem';
import { Stack } from '@mui/material';
import React from 'react';

const SectionPartner = () => (
  <Stack
    spacing={pr`23px`}
    alignItems="center"
    marginTop={pr`23px`}
  >
    <Stack
      spacing={pr`23px`}
      direction="row"
    >
      <img
        src="https://storage.googleapis.com/goyolo-production/vn-airline.png"
        alt="logo"
        className="lazyload"
        style={{
          width: '100px',
          objectFit: 'contain',
        }}
      />
      <img
        src="https://storage.googleapis.com/goyolo-production/vietjet-airline.png"
        alt="logo"
        className="lazyload"
        style={{
          width: '100px',
          objectFit: 'contain',
        }}
      />
      <img
        src="https://storage.googleapis.com/goyolo-production/bamboo-airline.png"
        alt="logo"
        className="lazyload"
        style={{
          width: '100px',
          objectFit: 'contain',
        }}
      />
    </Stack>
    <Stack
      direction="row"
      spacing={pr`14px`}
    >
      <img
        src="https://storage.googleapis.com/goyolo-production/mailinh.png"
        alt="logo"
        className="lazyload"
        style={{
          width: '100px',
          objectFit: 'contain',
        }}
      />
      <img
        src="https://storage.googleapis.com/goyolo-production/train.png"
        alt="logo"
        className="lazyload"
        style={{
          width: '100px',
          objectFit: 'contain',
        }}
      />
    </Stack>
  </Stack>
);

export default SectionPartner;
